import { Card, styled } from '@driftt/dds'

export const StyledCard = styled(Card, {
  width: '100%',
  height: '100%',
  maxWidth: '810px',
  maxHeight: '500px',
  padding: '$3',
})
